import { render } from "./menu_contacts.vue?vue&type=template&id=ebe598d2"
const script = {}

import exportComponent from "/Users/einaroberg/projects/tjing-majblomman/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__